import { registriereErpArt } from '../registry'
import { MontageEinstellungen } from './MontageEinstellungen'
import { MontageErpDetail } from './MontageErpDetail'
import { MontageErpVorzeige } from './MontageErpVorzeige'

/** AP-47-D — das Montageprotokoll meldet sich im ERP an: Vorzeige, Detailteil (Entwurf, Zuordnung, Mängelstand), Einstellungen mit Vorlagen. */
registriereErpArt({ kind: 'ASSEMBLY', Vorzeige: MontageErpVorzeige, Detail: MontageErpDetail, Einstellungen: MontageEinstellungen })
